/**
 * Created by amu33 on 30/09/2016.
 */
let social = {
        twitter: {
            type: "twitter",
            url: "http://twitter.com/amcodecouk",
        },
        github: {
            type: "github",
            url: "http://github.com/amcode",
        },
        instagram: {
            type: "instagram",
            url: "http://instagram.com/amcodecouk",
        },
        linkedin: {
            type: "linkedin",
            url: "https://www.linkedin.com/company/amcode",
        }
};
export default social;



/** WEBPACK FOOTER **
 ** ./app/data/social.js
 **/